import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PortfolioSection } from './components/PortfolioSection';
export function App() {
  return <div className="bg-bg-primary min-h-screen w-full" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <PortfolioSection data-id="element-4" />
      </main>
    </div>;
}